import React from 'react'
import { Avatar, Tabs } from 'antd'

export default (props) => {

  const { user, courses, payments } = props
  
  return <React.Fragment>
    <div className="profile-cover">
      <Avatar shape="square" size={64} icon="user"/>
      <h2>{user.email}</h2>
    </div>
    <div className="profile-tabs">
      <Tabs defaultActiveKey="1" onChange={props.tabChange}>
        <Tabs.TabPane tab="Basic" key="1">
          {props.basicDetailsTabContent(user)}
        </Tabs.TabPane>
        <Tabs.TabPane tab="My Courses" key="2">
          {props.myCoursesTabContent(courses)}
        </Tabs.TabPane>
        <Tabs.TabPane tab="Payments" key="3">
          {props.paymentTabContent(payments)}
        </Tabs.TabPane>
      </Tabs>
    </div>
  </React.Fragment>
}